import billableEventsCreateComponent from './billable_events.create.component';

let billableEventsCreateModule = angular.module('billableEventsCreate', [])

    .component('billableEventsCreate', billableEventsCreateComponent)

    .name;

export default billableEventsCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/create/index.js